var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ visible : _vm.visible },attrs:{"id":"back-top"},on:{"click":function($event){$event.preventDefault();return _vm.scrollToTop()}}},[_c('a',{attrs:{"href":"#"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }